import {BaseComponent} from '../../../abstract/base.component';
import {ErrorConstants} from '../../../shared/constants/error-constants';
import { Directive } from "@angular/core";

@Directive()
export abstract class GetPaymentDetailsAction extends BaseComponent {
  protected _getPaymentDetailsUrl: string;
  protected  _updatePaymentDescriptionUrl: string;
  protected  _updateReviewsUrl: string;
  protected _getTransactionPdf: string;
  protected postRetryTransactionUrl: string;

  protected getPaymentDetails() {
    this.loadFlag = true;
    console.log(this._getPaymentDetailsUrl);
    this.dataManager.getRequest(this._getPaymentDetailsUrl, 0)
      .subscribe(
        (response) => {
          this.passPaymentDetails(response);
          if (response.data.length === 0) {
            this.errorMsg = ErrorConstants.paymentDetailErrorMsg[0];
          } else {
            this.errorMsg = null;
          }
        },
        error => {
          this.errorMsg = this.networkErrorHandler(error.error, ErrorConstants.paymentDetailErrorMsg);
          this.passApiError(error); }
      );
  }

  protected  achChargePost(body) {
    this.loadFlag = true;
     
    
    this.dataManager.postRequest(this.postRetryTransactionUrl,body,0)
      .subscribe(res =>{
        this.loadFlag = false;
        this.passRetryTransactionResponse(res);
      },
      error=>{
        this.loadFlag = false;
        this.passRetryError(error);
        this.networkErrorHandler(error.error);
        
      })
  };
  protected abstract passPaymentDetails(paymentDetails);

  protected abstract passApiError(error);

  protected _updatePaymentDescription(postBody) {
    this.dataManager.patchRequest(this._updatePaymentDescriptionUrl, postBody)
      .subscribe(
        (res) => {
          this.passUpdatePaymentDescriptionResponse(res);
        },
        error => {
          this.networkErrorHandler(error.error);
          this.passUpdatePaymentDescriptionError(error.error);
        }
      );
  }
  protected updateReview(url) {
    this.dataManager.postRequest(this._updateReviewsUrl, url, 0)
      .subscribe(
        res => this.passUpdateResponse(res),
        err => {
          this.networkErrorHandler(err.error);
          this.passUpdateError(err.error);
        }
      );
  }
  getTransactionPDF() {
    this.loadFlag = true;
    this.dataManager.getRequestPdf(this._getTransactionPdf, 0).subscribe(
      (res) => {
        this.loadFlag = false;
        console.log('trans', res);
        this.passTransactionPdfResponse((new Blob([res], {type: 'application/pdf'})));
      },
      (err) => {
        this.loadFlag = false;
        this.passTransactionPdfError(err);
      },
      () => this.passTransactionPdfComplete()
    );
  }
  protected abstract passUpdateResponse(res);
  protected abstract passUpdateError(err);
  protected abstract passUpdatePaymentDescriptionResponse(res);
  protected abstract passTransactionPdfResponse(res);
  protected abstract passTransactionPdfError(error);
  protected abstract passTransactionPdfComplete();
  protected abstract passUpdatePaymentDescriptionError(error);
  protected abstract passRetryTransactionResponse(res);
  protected abstract passRetryError(error);
}
